import { render, staticRenderFns } from "./TimeModelEditorDialog.vue?vue&type=template&id=064f5384&scoped=true&lang=pug&"
import script from "./TimeModelEditorDialog.vue?vue&type=script&lang=ts&"
export * from "./TimeModelEditorDialog.vue?vue&type=script&lang=ts&"
import style0 from "./TimeModelEditorDialog.vue?vue&type=style&index=0&id=064f5384&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064f5384",
  null
  
)

export default component.exports